module.exports = __webpack_public_path__ + "static/img/1102.0bff559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/1102.png
// module id = 1vZC
// module chunks = 1